export interface StructuredNotesPreset {
  noteLabel: string;
  noteRequired?: boolean;
  notePlaceholder: string;
  noteHelperText: string;
  guidanceTitle: string;
  guidanceItems: string[];
  accessTitle: string;
  accessHint: string;
}

export type ApprovalNotesFlow = 'to_warek' | 'to_rapim';

export const getApprovalNotesPreset = (flow: ApprovalNotesFlow): StructuredNotesPreset => {
  if (flow === 'to_rapim') {
    return {
      noteLabel: 'Catatan & Rekomendasi Tindak Lanjut',
      noteRequired: false,
      notePlaceholder: 'Tuliskan catatan pengantar, poin pembahasan utama, dan rekomendasi tindak lanjut awal untuk bahan RAPIM...',
      noteHelperText: '',
      guidanceTitle: 'Yang Perlu Ditulis',
      guidanceItems: [
        'Ringkasan masalah dan alasan laporan perlu dibawa ke RAPIM.',
        'Catatan singkat atau arahan awal dari Warek terkait.',
        'Rekomendasi tindak lanjut, PIC usulan, atau keputusan yang perlu dibahas lebih lanjut.',
      ],
      accessTitle: 'Akses Pimpinan',
      accessHint: 'Catatan pengantar RAPIM ini tampil pada Riwayat Alur Laporan di halaman detail dan membantu Rektor, Sekretaris, serta peserta RAPIM memahami konteks pembahasan.',
    };
  }

  return {
    noteLabel: 'Catatan Persetujuan',
    noteRequired: false,
    notePlaceholder: 'Tuliskan ringkasan masalah, catatan penting, atau arahan singkat untuk Wakil Rektor terkait...',
    noteHelperText: 'Gunakan editor ini bila ada konteks tambahan yang perlu dibaca pada tahap validasi berikutnya.',
    guidanceTitle: 'Yang Perlu Ditulis',
    guidanceItems: [
      'Ringkasan masalah dan konteks penting yang perlu diketahui Wakil Rektor.',
      'Catatan awal atau arahan singkat dari Dekan atau Ketua Lembaga.',
      'Hal yang perlu mendapat perhatian pada tahap tindak lanjut berikutnya.',
    ],
    accessTitle: 'Akses Pimpinan',
    accessHint: 'Catatan persetujuan ini tampil di detail laporan dan dapat dibaca Wakil Rektor terkait, Rektor, serta Administrator.',
  };
};
